import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".3",
      "stroke-width": "1.25",
      d: "M7.333 12.665h-4A1.333 1.333 0 0 1 2 11.332V4.665a1.333 1.333 0 0 1 1.333-1.333h9.334A1.333 1.333 0 0 1 14 4.665v2.667",
      style: {"stroke":"color(display-p3 .6549 .6549 .6941)","stroke-opacity":".3"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FAFAFA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m4.667 6 2.666 2.667m0 0h-2m2 0v-2M9.334 9.999A.667.667 0 0 1 10 9.332h3.334a.667.667 0 0 1 .666.667v2a.667.667 0 0 1-.666.666H10A.667.667 0 0 1 9.334 12z",
      style: {"stroke":"color(display-p3 .9804 .9804 .9804)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }